import { useContext } from "react";

// @ts-expect-error -- untyped module
import mfaSuccess from "@/assets/mfa-success.svg";
import { Label } from "@/components/ui/label";
import { Button } from "@/components/ui/button";
// import { MfaViewState } from "@/pages/containers/mfa-container";
import { MFAContext, MfaViewState } from "@/context/mfa-provider";

const MfaSuccess = () => {
  const { setViewState } = useContext(MFAContext);

  return (
    <div className="flex flex-col justify-between gap-8 text-center sm:w-auto lg:w-[260px]">
      <div className="grid grid-cols-1 place-items-center gap-6">
        <img src={mfaSuccess} className="size-20" alt="" />
        <Label className="text-lg font-bold">Setup Success</Label>
        <div className="flex flex-col gap-1 text-center">
          <Label className="text-sm/6">
            Multi Factor Authentication setup successfully
          </Label>
        </div>
      </div>
      <div className="flex justify-center gap-4">
        <Button
          type="submit"
          className="w-32 rounded-sm"
          onClick={() => setViewState(MfaViewState.COMPLETE)}
        >
          Finish
        </Button>
      </div>
    </div>
  );
};

export default MfaSuccess;
